import { DEFAULT_PRODUCT_TYPE } from '../constants';

const VALID_PRODUCT_TYPES = [
  'accidental-medical',
  'vhis',
  'medical',
  'life',
  'critical-illness',
];
const PRODUCT_TYPE_MAPPING_KEY = {
  'accidental-medical': 'productMeta.accidentalMedical.name',
  vhis: 'productMeta.vhis.name',
  medical: 'productMeta.medical.name',
  life: 'productMeta.life.name',
  'critical-illness': 'productMeta.criticalIllness.name',
};
const DESCRIPTION_MAPPING_KEY = {
  'accidental-medical': 'productMeta.accidentalMedical.description',
  vhis: 'productMeta.vhis.description',
  medical: 'productMeta.medical.description',
  life: 'productMeta.life.description',
  'critical-illness': 'productMeta.criticalIllness.description',
};

export const getSafeProductType = (type: string): string =>
  VALID_PRODUCT_TYPES.includes(type) ? type : DEFAULT_PRODUCT_TYPE;

export const getTextByProduct = (type: string): Object => {
  const productType = getSafeProductType(type);

  const nameKey = PRODUCT_TYPE_MAPPING_KEY[productType];
  const descriptionKey = DESCRIPTION_MAPPING_KEY[productType];

  return {
    nameKey,
    descriptionKey,
  };
};
